import { render, staticRenderFns } from "./propertyCreditScoreDetails.vue?vue&type=template&id=fa7a4ef6&"
import script from "./propertyCreditScoreDetails.vue?vue&type=script&lang=js&"
export * from "./propertyCreditScoreDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports